import { Box, Button, useTheme } from "@mui/material";
import React from "react";

function ProductionStepTabs({ setActiveFilterType, activeFilterType }) {
  const theme = useTheme().palette.mode;
  const changeActiveFilterType = (type) => {
    setActiveFilterType(type);
  };

  return (
    <Box
      sx={{
        display: "flex",
        marginBottom: { md: 0, xs: "0.8rem" },
        width: "100%",
      }}
    >
      <Button
        onClick={() => changeActiveFilterType(1)}
        sx={{
          color: theme === "dark" ? "#FFF" : "#262D39",
          borderBottom:
            activeFilterType === 1 ? "2px solid rgba(30, 106, 253, 1)" : "",
        }}
      >
        برحسب ساعت ورود
      </Button>

      <Button
        onClick={() => changeActiveFilterType(2)}
        sx={{
          color: theme === "dark" ? "#FFF" : "#262D39",
          borderBottom:
            activeFilterType === 2 ? "2px solid rgba(30, 106, 253, 1)" : "",
        }}
      >
        برحسب اپراتور
      </Button>
    </Box>
  );
}

export default ProductionStepTabs;
